import { map } from "lodash";
import React from "react";
import SkeletonListItem from "../../../../../../components/SkeletonListItem";

import {
  formatDate,
  formatTime,
  parseTimestamp,
} from "../../../../../../utils/dateFns";

import {
  Column,
  ColumnContentWrapper,
  FlexWrapper,
  Header,
  HeaderRow,
  Row,
  Table,
  TBody,
  THead,
} from "./styles";

const ListLogTable = (props) => {
  const { isLoading } = props;

  const HeaderColumn = (headerProps) => {
    const { children, width } = headerProps;

    return (
      <Header width={width} clickable={false}>
        <FlexWrapper justify="space-between">{children}</FlexWrapper>
      </Header>
    );
  };

  const renderHeader = () => {
    return (
      <THead>
        <HeaderRow>
          <HeaderColumn id="nomeTabela">Nome da tabela</HeaderColumn>
          <HeaderColumn id="nomeCampo">Nome do campo</HeaderColumn>
          <HeaderColumn id="transacao">Transação</HeaderColumn>
          <HeaderColumn id="valorAnterior">Valor anterior</HeaderColumn>
          <HeaderColumn id="valorPosterior">Valor posterior</HeaderColumn>
          <HeaderColumn id="usuario">Usuário</HeaderColumn>
          <HeaderColumn id="dataRegistro">Data registro</HeaderColumn>
          <HeaderColumn id="usuarioMovimentacao">
            Usuario movimentação
          </HeaderColumn>
        </HeaderRow>
      </THead>
    );
  };

  const renderBody = () => {
    const { logs } = props;

    return (
      <TBody>
        {map(logs, (it) => {
          const parsedDate = parseTimestamp(it.dataRegistro);
          return (
            <Row key={it.id}>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.nomeTabela}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">{it.nomeCampo}</FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">{it.transacao}</FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.valorAnterior}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.valorPosterior}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">{it.usuario}</FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {formatDate(parsedDate)} {formatTime(parsedDate)}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.usuarioMovimentacao ?? it.usuarioCadastramento}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
            </Row>
          );
        })}
      </TBody>
    );
  };

  return (
    <>
      {isLoading ? (
        <SkeletonListItem />
      ) : (
        <Table>
          {renderHeader()}
          {renderBody()}
        </Table>
      )}
    </>
  );
};

export default ListLogTable;
